import { render, staticRenderFns } from "./FilePanel.vue?vue&type=template&id=120a0228&"
import script from "./FilePanel.vue?vue&type=script&lang=js&"
export * from "./FilePanel.vue?vue&type=script&lang=js&"
import style0 from "./FilePanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports